import type { TextSizes } from '@nautilusbio/nb-design-system';

// Class names belong in ./linkStyles.
const SIDEBAR_COLLAPSED_SIZE = 80;
const SIDEBAR_DEFAULT_SIZE = 214;
const SIDEBAR_MAX_SIZE = 420;
const SIDEBAR_MIN_SIZE = 209;

/** Icon size/strokeWidth config shared across sidebar link-style items */
const SIDEBAR_ICON_CONFIG = {
  collapsed: { size: 20, strokeWidth: 2 },
  expanded: { size: 16, strokeWidth: 1 },
} as const;

const sidebarTextSize: TextSizes = 'sm';

export {
  SIDEBAR_COLLAPSED_SIZE,
  SIDEBAR_DEFAULT_SIZE,
  SIDEBAR_MAX_SIZE,
  SIDEBAR_MIN_SIZE,
  SIDEBAR_ICON_CONFIG,
  sidebarTextSize,
};
